<template>
    <div class="vrm-remote-console-select">
        <div
            class="sg-custom-check-and-radio custom-radio vrm-remote-console-select__option"
            :class="{
                'vrm-remote-console-select__option--selected': selectedConsole === RC_CLASSIC,
                'vrm-remote-console-select__option--disabled':
                    selectedConsole !== RC_CLASSIC && (disabled || loading),
            }"
            @click="select(RC_CLASSIC)"
        >
            <div class="vrm-remote-console-select__option__illustration">
                <img src="/img/rc_ui_classic.png" alt="Classic UI illustration" />
            </div>

            <div class="vrm-remote-console-select__option__label">
                {{
                    $t('remoteconsole.choose_ui_label_classic', {
                        i18nFallback: 'Classic UI',
                    })
                }}

                <i
                    v-if="showArrows && (!loading || selectedConsole !== RC_CLASSIC)"
                    class="sg-vrm-icon_049_arrow-right-16px"
                ></i>
                <spinner v-if="showArrows && loading && selectedConsole === RC_CLASSIC"></spinner>
            </div>

            <div class="vrm-remote-console-select__option__overlay"></div>
        </div>

        <div
            class="sg-custom-check-and-radio custom-radio vrm-remote-console-select__option"
            :class="{
                'vrm-remote-console-select__option--selected': selectedConsole === RC_GUI_V2,
                'vrm-remote-console-select__option--disabled':
                    selectedConsole !== RC_GUI_V2 && (disabled || loading),
            }"
            @click="select(RC_GUI_V2)"
        >
            <div class="vrm-remote-console-select__option__illustration">
                <img src="/img/rc_ui_new.png" alt="New UI illustration" />
            </div>

            <div class="vrm-remote-console-select__option__label">
                {{
                    $t('remoteconsole.choose_ui_label_new', {
                        i18nFallback: 'New UI',
                    })
                }}

                <i
                    v-if="showArrows && (!loading || selectedConsole !== RC_GUI_V2)"
                    class="sg-vrm-icon_049_arrow-right-16px"
                ></i>
                <spinner v-if="showArrows && loading && selectedConsole === RC_GUI_V2"></spinner>
            </div>

            <div class="vrm-remote-console-select__option__overlay"></div>
        </div>
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import { REMOTE_CONSOLE_GUI_V2, REMOTE_CONSOLE_CLASSIC } from '@/constants/installations';
import Spinner from '@/vue/components/shared/device-controls/controls/components/Spinner.vue';

@Component({
    components: { Spinner },
    emits: ['change'],
})
@AngularDirective('vrm-remote-console-choice')
@AngularLocaleBundle('common')
@AngularLocaleBundle('remoteconsole')
export default class VrmRemoteConsoleChoice extends Vue {
    RC_GUI_V2 = REMOTE_CONSOLE_GUI_V2;
    RC_CLASSIC = REMOTE_CONSOLE_CLASSIC;

    /**
     * Selected console UI
     *
     * "rc_classic" or "rc_gui_v2"
     */
    @Prop({ type: String })
    selectedConsole;

    @Prop({ type: Boolean, default: false })
    disabled;

    @Prop({ type: Boolean, default: true })
    showArrows;

    @Prop({ type: Boolean, default: false })
    loading;

    select(choice) {
        if (!this.disabled && !this.loading) {
            this.$emit('change', choice);
        }
    }
}
</script>
